import React from 'react'
import { Field } from 'redux-form'
import renderSelect from '../fields/renderSelect'
import renderTextarea from '../fields/renderTextarea'
import i18n from '../../translations/i18n';

let TranslationOptions = props => {
	let lng = props.lng;

	let certification_options = props.certifications
	let index = certification_options.indexOf("None");
	if (index !== -1) {
		certification_options[index] = i18n.t('translation.none', {lng});
	}
	return (
		<div>
			<div className="form-section mt-5">
				<div className="subtitle title title-border title-border text-left">
					<h6>{i18n.t('translation.options_title', {lng})}</h6>
				</div>
				<div className="row">
					<div className="col-12 form-input">
						<Field
							name="targetCountry"
							component={renderSelect}
							label={i18n.t('translation.target_country', {lng})}
							placeholder={i18n.t('app.please_select', {lng})}
							options={props.countries}
						/>
					</div>
				</div>
				<div className="row form-section">
					<div className="col-12 form-input">
						<Field
							name="specialInstructions"
							component={renderTextarea}
							label={i18n.t('translation.special_instructions', {lng})}
							placeholder={i18n.t('translation.special_instructions_placeholder', {lng})}
						/>
					</div>
				</div>
			</div>
		</div>
	)
}


export default TranslationOptions


// WEBPACK FOOTER //
// ./src/components/translation/translations_options.js